"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Price = exports.Night = exports.Item = exports.Date = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _price = require("../../../../../../helpers/price");
var _fontSizeController = require("../../../../../../services/fontSizeController");
var _useRefPromise = require("../../../../../../services/useRefPromise");
var _pluralTranslations = require("../../../../../../localization/pluralTranslations");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PureItem = function PureItem(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultMatrixItem
  }, children);
};
var Item = exports.Item = (0, _react.memo)(PureItem);
var PureNightCell = function PureNightCell(_ref2) {
  var value = _ref2.value;
  var nightsTranslation = (0, _pluralTranslations.usePluralNightsTranslation)();
  return /*#__PURE__*/_react.default.createElement(Item, null, value && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, value, ' ', nightsTranslation(value)));
};
PureNightCell.propTypes = {
  value: _propTypes.default.number
};
var PureDateCell = function PureDateCell(_ref3) {
  var value = _ref3.value;
  var dateMoment = (0, _moment.default)(value);
  return /*#__PURE__*/_react.default.createElement(Item, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultMatrixDate
  }, dateMoment.format('DD'), ' ', dateMoment.format('MMM')), dateMoment.format('dd'));
};
PureDateCell.propTypes = {
  value: _propTypes.default.string.isRequired
};
var PurePriceCell = function PurePriceCell(_ref4) {
  var active = _ref4.active,
    currencySymbol = _ref4.currencySymbol,
    isMinPrice = _ref4.isMinPrice,
    food = _ref4.food,
    price = _ref4.price,
    onClick = _ref4.onClick;
  var priceForRender = (0, _price.preparePriceForRender)(price, currencySymbol);
  var textRefPromise = (0, _useRefPromise.useRefPromise)(null);
  var wrapperRefPromise = (0, _useRefPromise.useRefPromise)(null);
  var _useFontSizeControlle = (0, _fontSizeController.useFontSizeController)(textRefPromise, wrapperRefPromise),
    fontSize = _useFontSizeControlle.fontSize;
  return /*#__PURE__*/_react.default.createElement(Item, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.resultMatrixInner, _defineProperty({}, _styles.default.highlighted, active)),
    ref: wrapperRefPromise.setRef,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.resultMatrixPrice, _defineProperty({}, _styles.default.green, isMinPrice)),
    ref: textRefPromise.setRef,
    style: fontSize ? {
      fontSize: fontSize
    } : undefined
  }, priceForRender), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultMatrixFood
  }, food.toUpperCase())));
};
var Price = exports.Price = (0, _react.memo)(PurePriceCell);
var Night = exports.Night = (0, _react.memo)(PureNightCell);
var Date = exports.Date = (0, _react.memo)(PureDateCell);